import CircularProgress from "component/misc/CircularProgress";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { useTranslation } from "react-i18next";
import { translateSectorLabel } from "utils/sectorLabel";
import { formatReportDate, normalizePrecision } from "utils/formatReportDate";

const ReportDetailPanel = ({ progress, sectors, reading_time_minutes, create_date, published_date, published_precision, linkCount, source_logos, tags = [] }) => {
    const { t, i18n } = useTranslation();
    const precision = normalizePrecision(published_precision);
    let formattedDate = "";
    if (precision === "unknown") {
        // Erscheinungsdatum unbekannt: gar kein Datum zeigen (auch nicht das Importdatum).
        formattedDate = "";
    } else if (published_date) {
        // Erscheinungsdatum je nach Genauigkeit: "2026", "Q2 2026", "Oktober 2026"
        // oder tagesgenau. Es ist ein reines Datum (00:00 UTC), daher ohne Uhrzeit.
        formattedDate = formatReportDate(
            published_date,
            precision,
            i18n.resolvedLanguage || i18n.language,
            (d) => format(toZonedTime(d, "Europe/Berlin"), "dd.MM.yyyy")
        );
    } else {
        const rawDate = create_date ? new Date(create_date) : null;
        const isValidDate = rawDate && !isNaN(rawDate.getTime());
        const berlinTime = isValidDate ? toZonedTime(rawDate, "Europe/Berlin") : null;
        formattedDate = berlinTime ? format(berlinTime, "dd.MM.yyyy - HH:mm") : "";
    }
    const sectorLabel = (sector) => {
        if (typeof sector === "string") return sector;
        if (sector && typeof sector === "object") return sector.name || sector.slug || "";
        return "";
    };
    const parsedReadingTime = Number(reading_time_minutes);
    const readingMinutes = Number.isFinite(parsedReadingTime) && parsedReadingTime > 0
        ? Math.round(parsedReadingTime)
        : 1;

    return (
        <div className='custom_panel_box'>
            {/* Top Panel */}
            <div className=" mb-4 bg_glassEffect">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <span className="small">{formattedDate}</span>
                    <div className="d-flex align-items-center gap-2">
                        <span className="custom-readtime">{readingMinutes} {t("reports.readTime.min")}</span>
                        <CircularProgress progress={progress} />
                    </div>
                </div>

                <div className="news_detail d-flex justify-content-between align-items-center mb-4">
                    <span className="small">{t("news.tags")}</span>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        {Array.isArray(tags) && tags.length > 0
                          ? tags.slice(0, 6).map((tag, idx) => (
                              <span key={idx} className='category rounded-1 text-white'>{tag}</span>
                            ))
                          : sectors && sectors.slice(0, 2).map((sector, idx) => (
                              <span key={idx} className='category rounded-1 text-white'>{translateSectorLabel(sectorLabel(sector), i18n.resolvedLanguage || i18n.language)}</span>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportDetailPanel
